import { FC } from 'react';
import { Grid } from '@mui/material';
import StaffDocumentsGridView from './staffDocumentsGrid.view';
import { useStaffDocumentsState } from '../../contexts/staffDocuments.context';
import StaffManageDocumentView from './staffManageDocument.view';
import { PermissionGate } from '../../../../../components/rbac/PermissionGate';
import { RbacDeniedRedirect } from '../../../../../components/rbac/RbacDeniedRedirect';

const StaffDocumentsView: FC = () => {
  const {
    staffDocumentsAppState: { isLoading, isManageDocumentOpen },
  } = useStaffDocumentsState();

  return (
    <PermissionGate
      module="staff"
      submodule="documents"
      permission="read"
      fallback={<RbacDeniedRedirect />}
    >
      <Grid
        container
        spacing={{ xs: 1, sm: 2 }}
        sx={{
          height: '100%',
          p: { xs: 1, sm: 2 },
        }}
        data-testid="staff-documents-view-container"
      >
        <StaffDocumentsGridView isLoading={isLoading} />
        {isManageDocumentOpen && <StaffManageDocumentView />}
      </Grid>
    </PermissionGate>
  );
};

export default StaffDocumentsView;
